import { EventModule } from "app/event/EventModule"
import { IGeoShape, IShapeEventModule, IShapeOnSetParams, SHAPE_EVENTS } from "../shape/model"

class ShapeEventModule extends EventModule implements IShapeEventModule {
  public on = {
    onShapesAdd: (listenerId: string, fn: (shapes: IGeoShape[]) => void): void => {
      this.addListenerFn(SHAPE_EVENTS.SHAPES_ADD, listenerId, fn)
    },
    onShapesSet: (listenerId: string, fn: (params: IShapeOnSetParams) => void): void => {
      this.addListenerFn(SHAPE_EVENTS.SHAPES_SET, listenerId, fn)
    },
    onShapeDelete: (listenerId: string, fn: (shape: IGeoShape) => void): void => {
      this.addListenerFn(SHAPE_EVENTS.SHAPE_DELETE, listenerId, fn)
    },
    onShapesDelete: (listenerId: string, fn: (shapes: IGeoShape[]) => void): void => {
      this.addListenerFn(SHAPE_EVENTS.SHAPES_DELETE, listenerId, fn)
    }
  }
}

export const shapeEventModule: ShapeEventModule = new ShapeEventModule()
